import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "px-2 py-1 prompt-shell" }
const _hoisted_2 = { class: "connection-status" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "text-overline px-4" }
const _hoisted_5 = { class: "text-overline px-4" }
const _hoisted_6 = {
  ref: "chatArea",
  class: "chat-area"
}
const _hoisted_7 = { class: "tool-events-header" }
const _hoisted_8 = { class: "event-header" }
const _hoisted_9 = {
  key: 1,
  class: "event-message"
}
const _hoisted_10 = { class: "event-content" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "token-usage-display mb-3"
}
const _hoisted_13 = { class: "token-usage-value" }
const _hoisted_14 = { class: "text-subtitle-1" }
const _hoisted_15 = { class: "image-thumbnails-container" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = {
  key: 0,
  class: "stream-stop-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_ChatBubble = _resolveComponent("ChatBubble")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_vue_json_pretty = _resolveComponent("vue-json-pretty")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_FormattingCard = _resolveComponent("FormattingCard")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "px-0 py-0 ma-0 pa-0 prompt-container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_row, { class: "ma-0 pa-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "4",
              class: "ma-0 px-2 pt-0 pb-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                  onBlur: _ctx.onNameChange,
                  density: "compact",
                  variant: "outlined",
                  label: "Prompt name"
                }, null, 8, ["modelValue", "onBlur"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "4",
              class: "ma-0 px-2 pt-0 pb-1"
            }, {
              default: _withCtx(() => [
                (_ctx.targetList.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_select, {
                      key: 0,
                      modelValue: _ctx.selectedTarget,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTarget) = $event)),
                        _ctx.onTargetChange
                      ],
                      items: _ctx.targetList,
                      "item-title": "name",
                      "return-object": true,
                      label: "Target Model or Agent",
                      rules: [() => !!_ctx.selectedTarget || 'Target is required.'],
                      density: "compact",
                      variant: "outlined"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules"]))
                  : (_openBlock(), _createBlock(_component_v_select, {
                      key: 1,
                      modelValue: _ctx.selectedTarget,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTarget) = $event)),
                      items: _ctx.targetList,
                      "item-title": "name",
                      "return-object": true,
                      label: "Add models or agents to get started",
                      density: "compact",
                      variant: "outlined"
                    }, null, 8, ["modelValue", "items"]))
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "2",
              class: "ma-0 px-2 pt-0 pb-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.requestTimeout,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestTimeout) = $event)),
                  modelModifiers: { number: true },
                  onBlur: _ctx.onRequestTimeoutChange,
                  label: "Timeout (s)",
                  type: "number",
                  density: "compact",
                  variant: "outlined",
                  hint: "Request timeout (seconds)",
                  "persistent-hint": ""
                }, null, 8, ["modelValue", "onBlur"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "2",
              class: "ma-0 px-2 pt-0 pb-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.requestRetries,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestRetries) = $event)),
                  modelModifiers: { number: true },
                  onBlur: _ctx.onRequestRetriesChange,
                  label: "Retries",
                  type: "number",
                  density: "compact",
                  variant: "outlined",
                  hint: "Provider retry count",
                  "persistent-hint": ""
                }, null, 8, ["modelValue", "onBlur"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, { class: "ma-0 pa-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "5",
              class: "ma-0 px-2 pt-0 pb-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.selectedTargetImport,
                  "onUpdate:modelValue": [
                    _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedTargetImport) = $event)),
                    _ctx.importPrompt
                  ],
                  items: _ctx.agentTargets,
                  "item-title": "name",
                  "return-object": true,
                  label: "Load prompt from agent...",
                  density: "compact",
                  variant: "outlined"
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: "secondary",
                      icon: "mdi-arrow-down-bold-outline",
                      size: "x-large",
                      variant: "text",
                      density: "compact",
                      onMousedown: _ctx.stopProp,
                      onClick: _ctx.importPrompt,
                      disabled: _ctx.selectedTargetImport == null
                    }, null, 8, ["onMousedown", "onClick", "disabled"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "items", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "5",
              class: "ma-0 px-2 pt-0 pb-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.selectedTargetExport,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedTargetExport) = $event)),
                  items: _ctx.agentTargets,
                  "item-title": "name",
                  "return-object": true,
                  label: "Save prompt to agent...",
                  density: "compact",
                  variant: "outlined"
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: "secondary",
                      icon: "mdi-arrow-right-bold-outline",
                      size: "x-large",
                      variant: "text",
                      density: "compact",
                      onMousedown: _ctx.stopProp,
                      onClick: _ctx.exportPrompt,
                      disabled: _ctx.selectedTargetExport == null
                    }, null, 8, ["onMousedown", "onClick", "disabled"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "items"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, { class: "ma-0 pa-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "3",
              class: "ma-0 px-2 pt-1 pb-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tooltip, {
                  text: _ctx.isConnected ? 'Events listener connected' : 'Events listener disconnected'
                }, {
                  activator: _withCtx(({ props }) => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("span", _mergeProps({ class: "status-indicator" }, props, {
                        class: _ctx.isConnected ? 'connected' : 'disconnected'
                      }), null, 16)
                    ])
                  ]),
                  _: 1
                }, 8, ["text"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "3",
              class: "ma-0 px-2 pt-0 pb-4"
            }, {
              default: _withCtx(() => [
                (_ctx.waitingForAgent !== '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                      _createTextVNode(_toDisplayString(_ctx.waitingForAgent) + " responding  ", 1),
                      _createVNode(_component_ChatBubble, { class: "ml-4" })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "6",
              class: "ma-0 px-2 pt-0 pb-4 flex-column d-flex align-end"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_switch, {
                  modelValue: _ctx.enableStreaming,
                  "onUpdate:modelValue": [
                    _cache[7] || (_cache[7] = ($event: any) => ((_ctx.enableStreaming) = $event)),
                    _ctx.toggleStreaming
                  ],
                  color: "primary",
                  density: "compact",
                  variant: "inset",
                  "hide-details": "",
                  class: "mr-4"
                }, {
                  label: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.enableStreaming ? 'Streaming On' : 'Streaming Off'), 1),
                    _createVNode(_component_v_icon, { small: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.enableStreaming ? 'mdi-fast-forward' : 'mdi-play'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_v_switch, {
                  modelValue: _ctx.showToolEvents,
                  "onUpdate:modelValue": [
                    _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showToolEvents) = $event)),
                    _ctx.toggleToolEvents
                  ],
                  color: "secondary-darken-1",
                  density: "compact",
                  variant: "inset",
                  "hide-details": ""
                }, {
                  label: _withCtx(() => [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.showToolEvents ? 'Hide' : 'Show') + " Tool Events", 1),
                    _createVNode(_component_v_icon, { small: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.showToolEvents ? 'mdi-eye-off' : 'mdi-eye'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.context, (message, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `msg-${index}`,
              class: "message-item-wrapper mb-6",
              style: _normalizeStyle({ 'z-index': _ctx.context.length - index })
            }, [
              _createElementVNode("div", {
                class: "flip-container",
                style: _normalizeStyle({ height: _ctx.flipContainerHeights[index] ? _ctx.flipContainerHeights[index] + 'px' : 'auto' })
              }, [
                _createVNode(_Transition, {
                  name: "flip",
                  mode: "out-in",
                  onAfterEnter: () => _ctx.updateFlipContainerHeight(index)
                }, {
                  default: _withCtx(() => [
                    (_ctx.editingMessageIndex === index)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: `edit-${index}`,
                          ref_for: true,
                          ref: (el) => _ctx.setViewRef(el, index, 'edit'),
                          class: "flip-card mt-0 mx-0 pa-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "ma-0 pa-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card, {
                                  class: "pa-4",
                                  variant: "outlined",
                                  style: {"height":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      modelValue: message.role,
                                      "onUpdate:modelValue": ($event: any) => ((message.role) = $event),
                                      items: index === 0 ? _ctx.allRoles : _ctx.userRole,
                                      label: "Role",
                                      density: "compact",
                                      variant: "outlined",
                                      class: "mb-2",
                                      style: {"max-width":"200px"}
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items"]),
                                    _createVNode(_component_v_textarea, {
                                      modelValue: message.content,
                                      "onUpdate:modelValue": [($event: any) => ((message.content) = $event), () => _ctx.scheduleHeightUpdate(index)],
                                      label: "Content",
                                      "auto-grow": "",
                                      rows: "3",
                                      variant: "outlined"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_v_card_actions, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Button, {
                                          color: "warning",
                                          click: () => _ctx.removePrompt(index),
                                          icon: "mdi-delete-outline",
                                          tooltip: "Delete Message",
                                          size: "large"
                                        }, null, 8, ["click"]),
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          onClick: _cache[9] || (_cache[9] = () => _ctx.saveAndCloseEdit()),
                                          variant: "tonal",
                                          color: "primary"
                                        }, {
                                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                                            _createTextVNode("Done")
                                          ])),
                                          _: 1,
                                          __: [12]
                                        })
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createBlock(_component_v_row, {
                          key: `display-${index}`,
                          ref_for: true,
                          ref: (el) => _ctx.setViewRef(el, index, 'display'),
                          class: "flip-card mt-0 mx-0 pa-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "ma-0 pa-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card, {
                                  class: "mb-0",
                                  density: "compact",
                                  style: {"height":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "d-flex align-center py-2" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          icon: "",
                                          variant: "text",
                                          size: "x-small",
                                          onClick: () => _ctx.startEditing(index),
                                          title: "Edit message",
                                          class: "mr-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, null, {
                                              default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                _createTextVNode("mdi-pencil")
                                              ])),
                                              _: 1,
                                              __: [13]
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createElementVNode("span", null, "Role: " + _toDisplayString(message.role), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_divider),
                                    (message.role === 'assistant' && message.toolEvents && message.toolEvents.length > 0 && _ctx.showToolEvents)
                                      ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                                          key: 0,
                                          density: "compact",
                                          class: "mb-3"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_expansion_panel, { "bg-color": "background" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_expansion_panel_title, { color: "primary-darken-2" }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_7, [
                                                      _createElementVNode("span", null, "Tool Events (" + _toDisplayString(message.toolEvents.length) + ")", 1)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_expansion_panel_text, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_expansion_panels, { density: "compact" }, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.toolEvents, (event, eventIndex) => {
                                                          return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                                                            key: eventIndex,
                                                            class: _normalizeClass(['event-panel', _ctx.getEventTypeClass(event.type)]),
                                                            "bg-color": "background"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_expansion_panel_title, { color: "secondary-darken-2" }, {
                                                                default: _withCtx(() => [
                                                                  _createElementVNode("div", _hoisted_8, [
                                                                    (event.type)
                                                                      ? (_openBlock(), _createElementBlock("span", {
                                                                          key: 0,
                                                                          class: _normalizeClass(['event-badge', _ctx.getEventTypeClass(event.type), 'mr-4'])
                                                                        }, _toDisplayString(event.type), 3))
                                                                      : _createCommentVNode("", true),
                                                                    (event.message)
                                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(event.message), 1))
                                                                      : _createCommentVNode("", true)
                                                                  ])
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_expansion_panel_text, null, {
                                                                default: _withCtx(() => [
                                                                  _createElementVNode("div", _hoisted_10, [
                                                                    (_ctx.eventDataIsJson(event.data).isJson)
                                                                      ? (_openBlock(), _createBlock(_component_vue_json_pretty, {
                                                                          key: 0,
                                                                          data: _ctx.eventDataIsJson(event.data).data,
                                                                          deep: "4",
                                                                          theme: "dark"
                                                                        }, null, 8, ["data"]))
                                                                      : (_openBlock(), _createElementBlock("pre", _hoisted_11, _toDisplayString(event.data), 1))
                                                                  ])
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["class"]))
                                                        }), 128))
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_FormattingCard, {
                                      content: message.content,
                                      onVnodeUpdated: () => _ctx.scheduleHeightUpdate(index),
                                      onContentUpdated: () => _ctx.scheduleHeightUpdate(index),
                                      expanded: 'true',
                                      title: ''
                                    }, null, 8, ["content", "onVnodeUpdated", "onContentUpdated"])
                                  ]),
                                  _: 2
                                }, 1024),
                                (message.role === 'assistant' && message.tokenUsage)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "token-usage-label" }, "Tokens: ", -1)),
                                      _createElementVNode("span", _hoisted_13, " Prompt: " + _toDisplayString(message.tokenUsage.promptTokens) + " | Completion: " + _toDisplayString(message.tokenUsage.completionTokens) + " | Total: " + _toDisplayString(message.tokenUsage.totalTokens), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                  ]),
                  _: 2
                }, 1032, ["onAfterEnter"])
              ], 4)
            ], 4))
          }), 128))
        ], 512),
        (_ctx.waitingForAgent !== '')
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0,
              class: "mt-0 mx-0 mb-5 pa-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "ma-0 pa-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "mb-4",
                      density: "compact"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, [
                              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.waitingForAgent) + " responding", 1),
                              _createVNode(_component_ChatBubble, { class: "ml-4" })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.uploadedImages.length > 0)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 1,
              class: "ma-0 pa-0 mb-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "ma-0 pa-2"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadedImages, (image, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `img-${index}`,
                          class: "image-thumbnail-wrapper"
                        }, [
                          _createElementVNode("img", {
                            src: image.preview,
                            alt: image.fileName,
                            class: "image-thumbnail"
                          }, null, 8, _hoisted_16),
                          _createVNode(_component_v_btn, {
                            icon: "mdi-close-circle",
                            size: "x-large",
                            class: "delete-image-btn",
                            onClick: ($event: any) => (_ctx.removeImage(index)),
                            variant: "text",
                            color: "warning"
                          }, null, 8, ["onClick"])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_row, { class: "ma-0 pa-0 chat-input-row" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "ma-0 pa-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_textarea, {
                  modelValue: _ctx.chatInput,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.chatInput) = $event)),
                  class: "chat-input pt-1",
                  variant: "outlined",
                  density: "compact",
                  label: "Message...",
                  onKeydown: _withKeys(_withModifiers(_ctx.chat, ["meta"]), ["enter"]),
                  readonly: _ctx.waitingForAgent !== '',
                  "hide-details": "auto"
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_Button, {
                      color: "primary",
                      click: _ctx.selectImages,
                      icon: "mdi-plus",
                      size: "large",
                      tooltip: "Add images",
                      disabled: _ctx.waitingForAgent !== ''
                    }, null, 8, ["click", "disabled"])
                  ]),
                  append: _withCtx(() => [
                    (_ctx.isStreaming)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_v_progress_circular, {
                            color: "primary",
                            indeterminate: "",
                            size: "32",
                            width: "3"
                          }),
                          _createVNode(_component_v_btn, {
                            class: "stream-stop-btn",
                            color: "warning",
                            icon: "",
                            size: "x-small",
                            variant: "flat",
                            onClick: _ctx.stopStreamingChat
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "16" }, {
                                default: _withCtx(() => _cache[15] || (_cache[15] = [
                                  _createTextVNode("mdi-stop")
                                ])),
                                _: 1,
                                __: [15]
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          color: "primary",
                          click: _ctx.chat,
                          icon: "mdi-send-outline",
                          size: "x-large",
                          tooltip: "Send (⌘ + Enter)",
                          disabled: !_ctx.chatInput.trim() || _ctx.waitingForAgent !== ''
                        }, null, 8, ["click", "disabled"]))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onKeydown", "readonly"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("input", {
          ref: "hiddenFileInput",
          type: "file",
          accept: "image/jpeg,image/png,image/gif,image/webp",
          multiple: "",
          style: {"display":"none"},
          onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleFileInputChange && _ctx.handleFileInputChange(...args)))
        }, null, 544)
      ])
    ]),
    _: 1
  }))
}